// extracted by mini-css-extract-plugin
export default {"root":"CustomersHeader_root__6QYo3","aside":"CustomersHeader_aside__ZoCM5","countWrapper":"CustomersHeader_countWrapper__DzOeU"};